module.exports = __webpack_public_path__ + "img/132.62f05493.png";